export default __webpack_public_path__ + "static/media/ic-notification.54e1de57.svg";